import LoginWithOneTimeCode from './LoginWithOneTimeCode'

export default LoginWithOneTimeCode
